import { union } from '@wix/wix-data-client-common/dist/esm/infra/unionType'
import { isEqual } from 'lodash'

const DatasetWithRelationToAncestorRepeater = union(
  'DatasetRelationToAncestorRepeater',
  {
    Regular: dataset => dataset,
    Primary: dataset => dataset,
    Details: (dataset, repeaterControllerRef) => ({
      repeaterControllerRef,
      ...dataset,
    }),
    Other: (dataset, repeaterControllerRef) => ({
      repeaterControllerRef,
      ...dataset,
    }),
  },
)

const create = (dataset, repeaterAncestor, detailRefs = []) => {
  if (isEqual(dataset.controllerRef, repeaterAncestor.controllerRef)) {
    return DatasetWithRelationToAncestorRepeater.Primary(
      dataset,
      repeaterAncestor,
    )
  }
  if (
    detailRefs.some(controllerRef =>
      isEqual(dataset.controllerRef, controllerRef),
    )
  ) {
    return DatasetWithRelationToAncestorRepeater.Details(
      dataset,
      repeaterAncestor,
    )
  }
  return DatasetWithRelationToAncestorRepeater.Other(dataset, repeaterAncestor)
}

export { DatasetWithRelationToAncestorRepeater as Dataset, create }
